import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import axios from "axios";
import config from "react-global-configuration";
import { BeatLoader } from "react-spinners";
import { css } from "@emotion/core";
import jwt_decode from "jwt-decode";
import TeamDashboardProductFilter from "../../filters/TeamDashboardProductFilter.jsx";
import "./MondayOKRReport.css";

const DRILLDOWN_VALID_PRODUCTS = new Set([
    "Innoviti Unipay - Direct",
    "Innoviti Unipay - Aggregation",
    "Innoviti Genie",
    "Innoviti Link",
    "Innoviti Link - Healthcare",
    "Innoviti Link - Automotive"
]);

const spinnerOverride = css`
    display: block;
    margin: 40px auto;
`;

const formatNumber = (val) => {
    if (val === null || val === undefined || val === "") return val;
    if (typeof val !== "number" && isNaN(Number(val))) return val;
    const str = String(val);
    const dotIdx = str.indexOf(".");
    const fractionDigits = dotIdx === -1 ? 0 : str.length - dotIdx - 1;
    return Number(val).toLocaleString("en-IN", {
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
    });
};

class MondayOKRReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            months: [],
            loading: false,
        };
    }

    componentWillMount() {
        this.props.currentMenu && this.props.currentMenu("unipaynext");
    }

    componentDidMount() {
        try {
            const token = localStorage.usertoken;
            if (token) jwt_decode(token);
        } catch (e) {}
        this.fetchMetrics([]);
    }

    fetchMetrics = (productArray) => {
        this.setState({ loading: true });
        axios
            .post(
                config.get("API_URL") + "/reportdashboard/get-monday-okr-metrics",
                { products: productArray || [] },
                { headers: { Authorization: ` ${localStorage.usertoken}` } }
            )
            .then((response) => {
                const payload = response.data || {};
                this.setState({
                    data: payload.data || [],
                    months: payload.months || [],
                    loading: false,
                });
            })
            .catch((err) => {
                console.error("get-monday-okr-metrics error", err);
                this.setState({ loading: false, data: [], months: [] });
            });
    };

    handleProductChange = (optionSelected, productArray) => {
        this.fetchMetrics(productArray);
    };

    renderStatus = (isOnTrack) => {
        if (isOnTrack === null || isOnTrack === undefined || isOnTrack === "") {
            return <span className="okr-status okr-status-empty" />;
        }
        const onTrack = Number(isOnTrack) === 1;
        return (
            <span
                className={`okr-status ${onTrack ? "okr-status-green" : "okr-status-red"}`}
                title={onTrack ? "On track" : "Off track"}
            />
        );
    };

    buildBusinessTypeSpans = (data) => {
        const result = new Array(data.length).fill(0);
        let i = 0;
        while (i < data.length) {
            const bt = data[i].business_type || "";
            let j = i;
            let totalRows = 0;
            while (j < data.length && (data[j].business_type || "") === bt) {
                totalRows += (data[j].metrics || []).length;
                j++;
            }
            result[i] = totalRows;
            i = j;
        }
        return result;
    };

    handleMetricClick = (productName, metricName) => {
        if (!DRILLDOWN_VALID_PRODUCTS.has(productName)) return;
        this.props.history.push({
            pathname: "/admin/monday-okr-drilldown",
            search: `?product=${encodeURIComponent(productName)}&metric=${encodeURIComponent(metricName)}`,
        });
    };

    renderTableRows = () => {
        const { data, months } = this.state;
        const btSpans = this.buildBusinessTypeSpans(data);
        const rows = [];

        data.forEach((product, pIdx) => {
            const metrics = product.metrics || [];
            const tint = product.color || "#9CA3AF";
            const productName = product.product || "";
            const clickable = DRILLDOWN_VALID_PRODUCTS.has(productName);

            metrics.forEach((m, mIdx) => {
                const renderBt = mIdx === 0 && btSpans[pIdx] > 0;
                const renderProduct = mIdx === 0;
                rows.push(
                    <tr key={`row-${pIdx}-${mIdx}`}>
                        {renderBt && (
                            <td className="okr-bt-cell" rowSpan={btSpans[pIdx]}>
                                {product.business_type || "-"}
                            </td>
                        )}
                        {renderProduct && (
                            <td
                                className="okr-product-cell"
                                rowSpan={metrics.length}
                            >
                                {productName || "-"}
                            </td>
                        )}
                        <td
                            className={`okr-metric-cell ${clickable ? "okr-metric-link" : ""}`}
                            onClick={clickable ? () => this.handleMetricClick(productName, m.metric) : undefined}
                            title={clickable ? "View drilldown" : undefined}
                        >
                            {m.metric}
                        </td>
                        <td className="okr-center">{m.units}</td>
                        <td className="okr-resp">{m.responsibility}</td>
                        <td className="okr-num">{formatNumber(m.target)}</td>
                        <td className="okr-num">{formatNumber(m.mtd_target)}</td>
                        <td className="okr-center">{this.renderStatus(m.is_on_track)}</td>
                        {months.map((mo) => (
                            <td
                                key={mo}
                                className="okr-num okr-month-cell"
                                style={{ background: tint }}
                            >
                                {formatNumber(m[mo])}
                            </td>
                        ))}
                    </tr>
                );
            });
        });

        return rows;
    };

    render() {
        const { data, months, loading } = this.state;

        return (
            <div className="content-invoice monday-okr-report">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 pt-5">
                            <div className="card okr-card">
                                <div className="okr-header-row">
                                    <div className="okr-title-block">
                                        <h3 className="okr-title">Monday OKR Report</h3>
                                    </div>
                                    <div className="okr-header-filter">
                                        <label className="okr-filter-label">Product</label>
                                        <div className="okr-filter-control">
                                            <TeamDashboardProductFilter
                                                onSelectProduct={this.handleProductChange}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="okr-table-wrapper table-responsive">
                                    <table className="table okr-table">
                                        <colgroup>
                                            <col style={{ width: 100 }} />
                                            <col style={{ width: 140 }} />
                                            <col style={{ width: 180 }} />
                                            <col style={{ width: 60 }} />
                                            <col style={{ width: 100 }} />
                                            <col style={{ width: 80 }} />
                                            <col style={{ width: 90 }} />
                                            <col style={{ width: 60 }} />
                                            {months.map((m) => (
                                                <col key={`col-${m}`} style={{ width: 90 }} />
                                            ))}
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th>Business Type</th>
                                                <th>Product</th>
                                                <th>Metric</th>
                                                <th>Units</th>
                                                <th>Responsibility</th>
                                                <th>Target</th>
                                                <th>MTD Target</th>
                                                <th>Status</th>
                                                {months.map((m) => (
                                                    <th key={m}>{m}</th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loading ? (
                                                <tr>
                                                    <td colSpan={8 + months.length} className="okr-loading-cell">
                                                        <BeatLoader
                                                            css={spinnerOverride}
                                                            color={"#3B82F6"}
                                                            loading={true}
                                                        />
                                                    </td>
                                                </tr>
                                            ) : data.length === 0 ? (
                                                <tr>
                                                    <td colSpan={8 + months.length} className="okr-empty-cell">
                                                        No data available
                                                    </td>
                                                </tr>
                                            ) : (
                                                this.renderTableRows()
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    currentMenu: (name) => {
        dispatch({ type: "change_menu", payload: name });
    },
});

export default withRouter(connect(null, mapDispatchToProps)(MondayOKRReport));
